export const mobileWidth = 819;

export const languages: string[] = [
    'en',
    'ru',
    'be',
    'kk',
    'ja',
    'tr',
    'az',
    'uz',
    'bn',
    'uk',
    'fr',
    'pt',
    'es',
    'zh',
    'th',
    'pl',
    'ko',
    'vi',
    'de',
    'pt-br',
    'tr106',
    'en-alt',
    'hi',
    'es-soc',
    'de-soc',
    'fr-soc',
    'it-soc',
    'en-soc',
    'es_soc', //_
    'de_soc', //_
    'fr_soc', //_
    'it_soc', //_
    'en_soc', //_
    'en-fc',
];
export const languageByAlias: { [lang: string]: string } = {
    en: 'en',
    ru: 'ru',
    be: 'ru',
    kk: 'ru',
    ja: 'ja',
    tr: 'tr',
    az: 'az',
    uz: 'uz',
    bn: 'bn',
    uk: 'uk',
    fr: 'fr',
    pt: 'pt',
    es: 'es',
    zh: 'zh',
    th: 'th',
    pl: 'pl',
    ko: 'ko',
    vi: 'vi',
    de: 'de',
    'pt-br': 'pt_br',
    tr106: 'tr106',
    hi: 'hi',
    'es-soc': 'essoc',
    'de-soc': 'desoc',
    'fr-soc': 'frsoc',
    'it-soc': 'itsoc',
    'en-soc': 'en_soc',
    es_soc: 'essoc',
    en_soc: 'en_soc',
    de_soc: 'desoc',
    fr_soc: 'frsoc',
    it_soc: 'itsoc',
    'en-fc': 'en_fc',
};
export const defaultLanguage: string = 'en';

export const demoCID = 'democustomer';

/**
 * Apostaganha - client id: apostaganha
Atlas - client id: atlas
Cbetgg - client id: cbetgg
Cbetmx - client id: cbetmx
Vertbet - client id: vertbet
1win-infingame - client id: 1win-infingame-tg
Mrbet - client id: mrbet
Aposta1 - client id: aposta1-tg
Latamwin - client id: latamwincom-tg/latamwinpe-tg/latamwin-tg
Estelarbet - client id: estelarbet-tg
Softswiss sub: ultraplay revoada - client id: softswiss, sub_partner_id: ultraplay_revoada
Softswiss sub: pinup - client id: softswiss, sub_partner_id: pinup
Softswiss sub: roomcasino - client id: sofrswiss, sub_partner_id: roomcasino
Softswiss sub: premiergaming - client id: softswiss, sub_partner_id: premiergaming
Softswiss sub: brunocasino - client id: softswiss, sub_partner_id: brunocasino
Softswiss sub: cryptoleo - client id: softswiss, sub_partner_id: cryptoleo
Softswiss sub: betonred - client id: softswiss, sub_partner_id: betonred
Softswiss sub: pinupua - client id: softswiss, sub_partner_id: pinupua
Softswiss sub: goodman - client id: softswiss, sub_partner_id: goodman
Softswiss sub: skycrown - client id: softswiss, sub_partner_id: skycrown
Softswiss sub: bitvegas - client id: softswiss, sub_partner_id: bitvegas
Softswiss sub: rockwinio - client id: softswiss, sub_partner_id: rockwinio
Hub88 tgb - client id: hub88tgb
Hub88 tgc - client id: hub88tgc
Alea - client id: alea
Mostbet - client id: mostbet
Betandreas - client id:
Vivibet - client id: vivibet
Globonet - client id: globonet
Booi - client id: booi
Calimaco - client id: calimaco
bgs - client id: bgs
 * 
 * 
 */

export const customDeadClients = [
    { cid: 'apostaganha' },
    { cid: 'atlas' },
    { cid: 'cbetgg' },
    { cid: 'cbetmx' },
    { cid: 'vertbet' },
    { cid: '1win-infingame-tg' },
    { cid: 'aposta1-tg' },
    { cid: 'latamwincom-tg' },
    { cid: 'latamwinpe-tg' },
    { cid: 'latamwin-tg' },
    { cid: 'estelarbet-tg' },
    { cid: 'sofrswiss', sub: 'ultraplay_revoada' },
    { cid: 'softswiss', sub: 'pinup' },
    { cid: 'softswiss', sub: 'roomcasino' },
    { cid: 'softswiss', sub: 'premiergaming' },
    { cid: 'softswiss', sub: 'brunocasino' },
    { cid: 'softswiss', sub: 'cryptoleo' },
    { cid: 'softswiss', sub: 'betonred' },
    { cid: 'softswiss', sub: 'pinupua' },
    { cid: 'softswiss', sub: 'goodman' },
    { cid: 'softswiss', sub: 'skycrown' },
    { cid: 'softswiss', sub: 'bitvegas' },
    { cid: 'softswiss', sub: 'rockwinio' },
    { cid: 'hub88tgb' },
    { cid: 'hub88tgc' },
    { cid: 'alea' },
    { cid: 'mostbet' },
    { cid: 'betandreas' },
    { cid: 'vivibet' },
    { cid: 'globonet' },
    { cid: 'booi' },
    { cid: 'calimaco' },
    { cid: 'bgs' },
    { cid: 'nuxgame', sub: 'betbig' },
];

// export const clientPath =
//     process.env.CLIENT_PUBLIC_URL && process.env.CLIENT_PUBLIC_URL !== '/'
//         ? `/${process.env.CLIENT_PATH}`
//         : '';

export const clientPath = window.location.origin.includes('localhost')
    ? ''
    : process.env.CLIENT_PUBLIC_URL && process.env.CLIENT_PUBLIC_URL !== '/'
    ? process.env.CLIENT_PUBLIC_URL
    : '';
